import EnvSettings from "../../Utils/EnvSettings";
import { getToken } from "../../Utils/Common";

export async function taskRequest(endpoint, body = {}) {
  const multipart = body instanceof FormData;
  if (multipart) body.set("token", getToken());
  const response = await fetch(`${EnvSettings.server}/${endpoint}`, {
    method: "POST",
    ...(multipart ? {} : { headers: { "Content-Type": "application/json" } }),
    body: multipart ? body : JSON.stringify({ ...body, token: getToken() }),
  });
  const result = await response.json();
  if (!response.ok || result.error) throw new Error(result.message || "Unable to load or save tasks.");
  return result;
}
